import { ReactNode } from 'react';
import { Box } from '@nimbus-ds/components';
import { useHistory } from 'react-router-dom';
import { BILLING_NEW_FLOW_FREQUENCY } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { HeaderTop, IonPageStratus, Layout } from 'commons/components';
import PayOrderSummary from '../PayOrderSummary';
import RecurrentPaymentAlert from '../RecurrentPaymentAlert';

interface ChoosePaymentMethodWithRecurrencyLayoutProps {
  mainContent: ReactNode;
}

export default function ChoosePaymentMethodWithRecurrencyLayout({
  mainContent,
}: Readonly<ChoosePaymentMethodWithRecurrencyLayoutProps>) {
  const { goBack } = useHistory();
  const backNavigation = {
    onClick: goBack,
  };
  const [hasRecurrencyTag] = useHasTags(BILLING_NEW_FLOW_FREQUENCY);

  return (
    <IonPageStratus
      headerTop={<HeaderTop navigation={backNavigation} />}
      width="large"
    >
      <Layout
        mainContent
        left={
          <>
            <RecurrentPaymentAlert />
            {mainContent}
          </>
        }
        right={
          <Box display="flex" flexDirection="column" flexGrow="1">
            <PayOrderSummary showTaxes showPeriodDiscounts={hasRecurrencyTag} />
          </Box>
        }
        orderMobile="reverse"
      />
    </IonPageStratus>
  );
}
